export const ROUTE_PAGE = {
  INICIO: "/",
  CONFIGURACION:{
    IMPRESORA:'/impresora/config',
  },
  HOME: {
    VER: "/home",
  },
  ERROR_PAGE: {
    "404": "/404",
  },
  AUTH: {
    LOGIN: "/login",
  },
  SERVICIO:{
    LISTAR: "/servicio/otros",
    EDITAR: "/servicio/editar/:id",
    CREAR:"/servicio/otros/crear",
  },
  PLANILLA: {
    //VER: '/boleto/crear/n/:id',
    VER: "/planilla/crear/:id",
    NEW: "/planilla/crear/:id",
  },
  REGISTRO_CONTABLE: {
    CREAR: "/registro/cuenta",
  },
  PLAN_CUENTA: {
    CREAR: "/plan/cuenta",
  },
  //AJUSTE
  EMPRESA: {
    LISTAR: "/empresa",
    //NUEVO: "/empresa/nuevo",
    EDITAR: "/empresa/editar/:id",
    CREAR: "/empresa/crear",
  },
  ROLPRIVI: {
    LISTAR: "/rol",
    NUEVO: "/rol/nuevo",
    EDITAR: "/rol/edicion/:id",
  },
  FUNCIONALIDAD: {
    LISTAR: "/funcionalidad",
    NUEVO: "/funcionalidad/nuevo",
    EDITAR: "/funcionalidad/nodo/:id",
    NUEVO2: "/funcionalidad/new",
  },
  PAQUETE: {
    LISTAR: "/paquete",
    NUEVO: "/paquete/nuevo",
  },
  COMPONENTE: {
    LISTAR: "/componente",
    NUEVO: "/componente/nuevo",
  },
  TERMINAL: {
    LISTAR: "/terminal",
    NUEVO: "/terminal/nuevo",
    EDITAR:"/terminal/editar/:id"
  },
  //ADMINISTRACION
  PERFIL: {
    EDITAR: "/perfil/edicion",
  },
  TIPOPERSONAL: {
    NUEVO: "/tipopersonal/nuevo",
    EDITAR: "/tipopersonal/editar/:id",
    LISTAR: "/tipopersonal",
  },
  PRS_EMPRESA: {
    NUEVO: "/personal/empresa/nuevo",
    EDITAR: "/personal/empresa/editar/:id",
    LISTAR: "/personal/empresa",
  },
  SUCURSAL: {
    NUEVO: "/sucursal/nuevo/",
    LISTAR: "/sucursal",
    EDITAR: "/sucursal/editar/:id",
  },
  BUSNIT: {
    NUEVO: "/bus/nit/nuevo",
    LISTAR: "/bus/nit",
    EDITAR: "/bus/nit/editar/:id",
  },
  ///PLANIFICACION
  PLANIFICACION: {
    LISTAR: "/planificacion",
    NUEVO: "/planificacion/nuevo",
    EDITAR: "/planificacion/editar/:id",
  },
  ///VIAJE
  VIAJE: {
    LISTAR: "/viaje",
    PERSONAL: "/viaje/personal/:id",
    ABORDO: "/viaje/abordo/:id",
    PASAJEROS: "/viaje/pasajeros/:id",
    GRAFICO: "/venta/viaje/:id",
    RESERVAS: "/viaje/reserva/",
    GRAFICO_ENCOMIENDA: "/venta/encomienda/:id",
    BUSQUEDA_VIAJE: "/viaje/busqueda",
  },
  BOLETO: {
    CREAR: "/boleto/crear/new/:id",
  },
  TRASLADO: {
    LISTA: "/viaje/traslado/:id",
    CREAR: "/viaje/traslado/crear/:id",
  },
  RUTA: {
    LISTA: "/ruta",
    NUEVO: "/ruta/nuevo",
    TRAMO: "/ruta/tramo/:id",
    EDITAR: "/ruta/editar/:id",
    HORARIO: {
      LISTAR: "/ruta/horario/:id",
      CREAR: "/ruta/horario/crear/:id",
      EDITAR: "/ruta/horario/editar/:id",
    },
  },
  //TRANSPORTE
  TRANSPORTE: {
    LISTAR: "/transporte",
    EDITAR:"/transporte/editar/:id",
    MEDIA: "/transporte/galeria/:id",
    CREAR: "/transporte/nuevo",
    DESIGN: "/transporte/disposicion/:id",
    DESIGN2: "/transporte2/disposicion/:id",
  },
  PUNTO_ABORDAJE: {
    LISTA: "/punto-abordaje",
    NUEVO: "/punto-abordaje/nuevo",
    EDITAR: "/punto-abordaje/editar/:id",
  },
  //ENCOMIENDA
  TIPOOBJETO: {
    NUEVO: "/encomienda/tipoobjeto/nuevo",
    EDITAR: "/encomienda/tipoobjeto/editar/:id",
    LISTAR: "/encomienda/tipoobjeto",
  },
  TIPOSOLICITUD: {
    NUEVO: "/encomienda/tiposolicitud/nuevo",
    EDITAR: "/encomienda/tiposolicitud/editar/:id",
    LISTAR: "/encomienda/tiposolicitud",
  },
  TIPOSERVICIO: {
    NUEVO: "/encomienda/tiposervicio/nuevo",
    EDITAR: "/encomienda/tiposervicio/editar/:id",
    LISTAR: "/encomienda/tiposervicio",
  },
  MEDIOTRANSPORTE: {
    LISTAR: "/despacho",
    NUEVO: "/despacho/nuevo",
  },
  TIPOCUIDADO: {
    NUEVO: "/encomienda/tipocuidado/nuevo",
    EDITAR: "/encomienda/tipocuidado/editar/:id",
    LISTAR: "/encomienda/tipocuidado",
  },
  VIAJE_ENCOMIENDA: {
    NUEVO: "/encomienda/viaje/nuevo",
    EDITAR: "/encomienda/viaje/editar/:id",
    LISTAR: "/encomienda/viaje",
  },
  ENCOMIENDA: {
    EMBARQUE: "/encomienda/embarque",
    DESEMBARQUE: "/encomienda/desembarque"
  },
  BODEGA: {
    LISTAR: "/encomienda/bodega",
    NUEVO: "/encomienda/bodega/nuevo",
    EDITAR: "/encomienda/bodega/editar",
  },
  SEGUIMIENTO: {
    BUSCAR: "/encomienda/seguimiento/buscar",
  },
  BUSQUEDA: {
    BUSCAR: "/encomienda/busqueda/buscar",
  },
  //
  NIT: {
    LISTA: "/nit",
    NUEVO: "/nit/nuevo",
    EDITAR: "/nit/editar/:id",
    SUCURSAL: "/nit/sucursal/:id",
    LIBRO_VENTA:"/nit/libroventa",
    CERTIFICACION:"/nit/facturacion/certificacion"
  },
  DISPOSICION: {
    LISTA: "/disposicion",
    NUEVO: "/disposicion/nuevo",
    EDITAR: "/disposicion/editar/:id",
  },
  SOLICITUD: {
    LISTAR: "/solicitud",
    NUEVO: "/solicitud/nuevo",
    EDITAR: "/solicitud/editar/:id",
    DETALLE: "/solicitud/detalle/:id",
    GUIA: "/solicitud/guia",
    SEGUIMIENTO:"/solicitud/seguimiento/entrega"
  },
  DOSIFICACION: {
    LISTAR: "/dosificacion",
    NUEVO: "/dosificacion/nuevo",
  },
  USUARIO: {
    LISTA: "/usuario/",
    SESION: "/usuario/sesion",
  },
  //REPORTE GENERAL
  REPORTE_GENERAL: {
    LISTA: "/reporte/general/ventas",
  },
  // REPORTE GENERAL ENCOMIENDAS
  REPORTE_GENERAL_ENCOMIENDAS: {
    LISTA: "/reporte/general/encomiendas",
  },
  RESERVA: {
    BUSQUEDA: "/busqueda/reserva",
  },
  TUVI: {
    LISTA: "/venta/tuvi/listar",
    INFORME: "/venta/tuvi/informe",
  },
  GASTO: {
    NUEVO: "/gasto/viaje/:id/:ruta",
  },
  UBICACION: {
    LISTAR: "/ubicacion",
  },
};

export function PARAM(route: string, param: any | object) {
  //Si el object esta vacio
  let isEmpty = (data: any) => {
    return Object.keys(data).length === 0;
  };
  //Si es un object
  let isObject = (data: any) => {
    return typeof data === "object" && data !== null && data !== undefined;
  };
  let copyUrl = route;
  if (isObject(param) && !isEmpty(param)) {
    Object.keys(param).forEach((key) => {
      copyUrl = copyUrl.replace(":" + key, param[key] as string);
    });
  }
  return copyUrl;
}
